export type StepIdType =
  | "picksaved"
  | "personalizare.nume"
  | "personalizare.despre"
  | "personalizare.poveste"
  | "summary"
  | "payment"
  | "login";

export interface StepType {
  id: StepIdType;
  label: string;
  path: string;
}

export const PICKSAVED_STEP: StepType = {
  id: "picksaved",
  label: "Profil salvat",
  path: "/comanda/salvate",
};

export const BASE_STEPS: StepType[] = [
  {
    id: "personalizare.nume",
    label: "Nume",
    path: "/comanda/personalizare/nume",
  },
  {
    id: "personalizare.despre",
    label: "Portret",
    path: "/comanda/personalizare/despre",
  },
  {
    id: "personalizare.poveste",
    label: "Poveste",
    path: "/comanda/personalizare/poveste",
  },
];

export const SUMMARY_STEP: StepType = {
  id: "summary",
  label: "Sumar",
  path: "/comanda/sumar",
};

export const PAYMENT_STEP: StepType = {
  id: "payment",
  label: "Plată",
  path: "/comanda/plata",
};

export const AUTH_STEP: StepType = {
  id: "login",
  label: "Autentificare",
  path: "/comanda/autentificare",
};
